import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ConsultationModal from './ConsultationModal'; // Adjust path as needed

const CTAConsultation = ({ ctaType, specificService = '', companyName = '' }) => {
  const [showModal, setShowModal] = useState(false);

  const ctaConfig = {
    general: 'Book Your Consultation',
    career: 'Start Your Career Transformation',
    hrService: 'Explore HR Solutions',
    specificService: `Request ${specificService || 'Custom Service'}`,
  };

  return (
    <>
      <motion.button
        className="inline-block bg-[#0e6d87] text-white px-6 py-3 rounded-full text-base sm:text-lg font-medium hover:bg-[#0b566a] hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
        onClick={() => setShowModal(true)}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        {ctaConfig[ctaType] || ctaConfig.general}
      </motion.button>
      <ConsultationModal
        showModal={showModal}
        setShowModal={setShowModal}
        ctaType={ctaType}
        specificService={specificService}
        companyName={companyName}
      />
    </>
  );
};

export default CTAConsultation;